import { css } from '@emotion/react';
import React, { HTMLAttributes, ReactNode } from 'react';

import { Box } from '../Box';
import { media } from '../shared/styles';
import { LayoutTokens } from './utils';

export interface GridContainerProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * Maximum width constraint
   */
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | 'content' | 'wide' | 'full' | string;
  /**
   * Container children
   */
  children: ReactNode;
  /**
   * Additional CSS class names
   */
  className?: string;
}

const baseContainerStyles = css`
  width: 100%;
  margin: 0 auto;
  padding-left: 1rem;
  padding-right: 1rem;
`;

const generateMaxWidthStyles = (maxWidth: string) => {
  if (maxWidth === 'full') {
    return css`
      max-width: 100%;
      padding-left: 0;
      padding-right: 0;
    `;
  }

  const width =
    LayoutTokens.containers[maxWidth as keyof typeof LayoutTokens.containers] ||
    maxWidth;

  return css`
    max-width: ${width};

    ${media.sm} {
      padding-left: 1.5rem;
      padding-right: 1.5rem;
    }

    ${media.lg} {
      padding-left: 2rem;
      padding-right: 2rem;
    }

    ${media.xl} {
      padding-left: 3rem;
      padding-right: 3rem;
    }
  `;
};

const GridContainer = ({
  maxWidth = 'xl',
  children,
  className,
  ...props
}: GridContainerProps) => {
  const containerStyles = [
    baseContainerStyles,
    generateMaxWidthStyles(maxWidth),
  ];

  return (
    <Box css={containerStyles} className={className} {...props}>
      {children}
    </Box>
  );
};

export default GridContainer;
